import { render, staticRenderFns } from "./RenewalInplayDetail.vue?vue&type=template&id=b55393fa&scoped=true"
import script from "./RenewalInplayDetail.vue?vue&type=script&lang=js"
export * from "./RenewalInplayDetail.vue?vue&type=script&lang=js"
import style0 from "./RenewalInplayDetail.vue?vue&type=style&index=0&id=b55393fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55393fa",
  null
  
)

export default component.exports